import React, { Component } from "react";
import { Link } from "react-router-dom";
import "../css/bootstrap.css";
import "../css/style-min.css";
import "../css/responsive-min.css";
// import "../css/style.css";
// import "../css/responsive.css";
import logo from "../images/logo.webp";
import Phn from "../images/phone.webp";
import menu from "../images/menu.webp";
import $ from "jquery";
class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
    mobileNo:
      (this.props.serviceStation)
        ? this.props.serviceStation.mobileNo
        : "",
  };
}
  menuClick() {
    $(".menulist").addClass("menulist-active");
  }
  menuClose() {
    $(".menulist").removeClass("menulist-active");
  }
  render() {
    return (
      <header className="header">
        <nav  role="navigation"  aria-label="main navigation" className="header-nav">
          <div className="container header-nav-container">
            <div className="menuIcon" onClick={() => this.menuClick()}>
                  {/* <img src={menu} alt="menu" className="menuimg"
                    width="44"
                    height="20" /> */}
                    
                <div className="menubar__icon menuimg">
                  <div className="menubar__icon01"></div>
                  <div className="menubar__icon01"></div>
                  <div className="menubar__icon01"></div>
                </div>
              </div>
              <div className="logo" title="AXIS BANK">
                <a href="/">
                  <img src={logo} alt="logo" className="iocl-logo" width="189" height="45" />
                </a>
              </div>
                {/* <p className="pull-right transalte">Translate</p> */}
              <div className="menulist">
                  <div className="menuClose" onClick={() => this.menuClose()}>×</div>
                  <ul className="menulist-ul">
                      <li className="menulist-li">
                        <a href="https://www.axis.bank.in/?cta=branch-home" target="_blank" rel="noopener noreferrer">Home</a>
                      </li>
                      <li className="menulist-li">
                        <a href="https://www.axis.bank.in/sitemap?cta=branch-explore-products" target="_blank" rel="noopener noreferrer">Explore Products</a>
                      </li>
                      <li className="menulist-li">
                        <a href="https://www.axis.bank.in/offers-rewards?cta=branch-grab-deals" target="_blank" rel="noopener noreferrer">Grab Deals</a>
                      </li>
                      <li className="menulist-li">
                        <a href="https://www.axis.bank.in/payments?cta=branch-make-payment" target="_blank" rel="noopener noreferrer">Make Payment</a>
                      </li>
                      <li className="menulist-li">
                        <a href="https://www.axis.bank.in/bank-smart/internet-banking?cta=branch-bank-smart" target="_blank" rel="noopener noreferrer">Bank Smart</a>
                      </li>
                      <li className="menulist-li menulist-liMob">
                        {/* {this.state.mobileNo !== "" && ( */}
                            <>
                            <img
                              src={Phn}
                              className="head-phn"
                              alt="Phn"
                              width="44"
                              height="20"
                            />
                            <a className="phn-txt" href={ "tel:18002333555" }> 18604195555</a>
                            </>
                        {/* )}{" "} */}
                      </li>
                    </ul>
              </div> 
          </div>
        </nav>
      </header>
    );
  }
}
export default Header;
